export default __webpack_public_path__ + "static/media/fold.0de9b04b.png";